export default function CTABanner() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="w-full py-12 md:py-16 bg-primary-500">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-heading font-bold text-xl md:text-2xl text-background-50 mb-2">
              Ready to transform your technology or talent strategy?
            </h3>
            <p className="text-sm md:text-base text-background-200">
              Schedule a free consultation with our enterprise specialists.
            </p>
          </div>
          <button
            onClick={() => handleNavClick("#contact")}
            className="px-6 py-3.5 text-sm font-semibold rounded-md bg-background-50 text-primary-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer shrink-0"
          >
            Talk to Our Experts
          </button>
        </div>
      </div>
    </section>
  );
}